import { Component, Vue } from "vue-property-decorator";
import UserValidator from "@/resources/mixins/userValidator";
import { mixins } from "vue-class-component";
@Component({})
export default class Plans extends mixins(UserValidator) {
    debug = process.env.VUE_APP_ENVIRONMENT === "DEV" ? true : false;
    MAX_SPACES = "maxSpaces";
    MAX_USERS_CONNECTED = "maxUsersConnected";
    TYPE_PLAN = "plan";
    activeOptionPlan(option: string): boolean {
        if (this.dataSpace && this.dataSpace.hasOwnProperty(option)) {
            if (this.debug) console.log("Plans activeOptionPlan IF THE PROPERTY EXISTS ", option, this.dataSpace[option]);
            return this.dataSpace[option];
        } else {
            if (this.debug) console.log("Plans activeOptionPlan THE PROPERTY DOES NOT EXIST ", option);
        }
        return false;
    }

    getMaxSpaces(): number {
        if (this.dataSpace) {
            if (this.debug) console.log("Plans getMaxSpaces ", this.dataSpace[this.MAX_SPACES]);
            return this.dataSpace[this.MAX_SPACES];
        }
    }

    getMaxUsersConnectd(): number {
        if (this.dataSpace) {
            if (this.debug) console.log("Plans getMaxUsersConnectd ", this.dataSpace[this.MAX_USERS_CONNECTED]);
            return this.dataSpace[this.MAX_USERS_CONNECTED];
        }
    }

    getPlan() {
        if (this.dataSpace) {
            if (this.debug) console.log("Plans getPlan ", this.dataSpace[this.TYPE_PLAN]);
            return this.dataSpace[this.TYPE_PLAN];
        }
        return "FREE";
    }

    get dataSpace() {
        let space = this.$store.getters["SpaceStore/getSpace"];
        if (space && space.superSpace && space.superSpace.featurePlan) {
            return space.superSpace.featurePlan
        }
        else if(this.superSpace && this.superSpace.featurePlan) {
            return this.superSpace.featurePlan;
        }
    }

    //Only used in super space admin mode
    get superSpace(): any {
        let superSpace = this.$store.getters["SuperSpaceStore/getSuperSpace"];
        if (superSpace)
            return superSpace;
    }
}